<template>
    <div>
        <dynamic-toolbar
            :icon="'mdi-file-document-multiple'"
            :title="'Maintenance Catalogs'"
            :color="'indigo'"
            :theme="'dark'"
        />
        <v-container fluid>
            <v-tabs
                v-model="tab"
                background-color="indigo"
                dark
                grow
                show-arrows
                @change="selectCatalog"
            >
                <v-tab
                    v-for="catalog in catalogs"
                    :key="catalog.name"
                    :href="'#' + catalog.name"
                >
                    {{ catalog.name }}
                </v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab">
                <v-tab-item
                    v-for="catalog in catalogs"
                    :key="catalog.name"
                    :value="catalog.name"
                >
                    <v-row justify="center">
                        <v-col cols="12">
                            <expense-type-category-subcategory
                                :categories="catalog.items"
                                v-if="catalog.name === 'Expense Categories'"
                            />
                            <tax-regions
                                :regions="catalog.items"
                                :headers="catalog.headers"
                                @update="loadCatalog(catalog.catalogKey)"
                                @open-context-menu="openContextMenu"
                                v-if="catalog.name === 'Tax Regions'"
                            />
                            <maintenance-vendors
                                :maintenanceVendors="catalog.items"
                                :headers="catalog.headers"
                                @update="loadCatalog(catalog.catalogKey)"
                                @open-context-menu="openContextMenu"
                                v-if="catalog.name === 'Maintenance Vendors'"
                            />
                            <!-- <rent-agreements
                                :agreements="catalog.items"
                                :headers="catalog.headers"
                                v-if="catalog.name === 'Rent Agreements'"
                            /> -->
                            <maintenance-tire-brands
                                :maintenanceTireBrands="catalog.items"
                                :headers="catalog.headers"
                                @update="loadCatalog(catalog.catalogKey)"
                                @open-context-menu="openContextMenu"
                                v-if="catalog.name === 'Tire Brands'"
                            />
                            <maintenance-items
                                :items="catalog.items"
                                :headers="catalog.headers"
                                @update="loadCatalog(catalog.catalogKey)"
                                @open-context-menu="openContextMenu"
                                v-if="catalog.name === 'Items/Parts'"
                            />
                            <!--<maintenance-inventory
                                :inventory="catalog.items"
                                :headers="catalog.headers"
                                v-if="catalog.name === 'Inventory'"
                            />-->
                        </v-col>
                    </v-row>
                </v-tab-item>
            </v-tabs-items>
        </v-container>

        <vue-context ref="catalogItem" style="padding: 0;margin: 0;">
            <template slot-scope="selectedItem" v-if="selectedItem.data">
                <v-list dense>
                    <v-list-item 
                        @click="deleteItem(selectedItem.data)"
                    >
                        <v-list-item-icon>
                            <v-icon color="error">mdi-trash-can</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>Delete item</v-list-item-title>
                    </v-list-item>
                </v-list>
            </template>
        </vue-context>

        <v-dialog v-model="deleteDialog" max-width="500px">
            <v-card>
                <v-card-title class="headline">Are you sure?</v-card-title>
                <v-card-text>
                    This action will delete the element. Do you want to continue?
                </v-card-text>

                <v-card-actions>
                    <v-btn color="indigo" outlined @click="deleteDialog = false">
                        Cancel
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="error" dark @click="confirmDelete">
                        Delete
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
function logErr(error) {
    console.log(error);
}

import VueContext from 'vue-context';
import DynamicToolbar from '../../components/Global/Utils/DynamicToolbar.vue';

import ExpenseTypeCategorySubcategory from '../../components/Catalogs/Maintenance/ExpenseTypeCategorySubcategory.vue';
import TaxRegions from '../../components/Catalogs/Maintenance/TaxRegions.vue';
import MaintenanceVendors from '../../components/Catalogs/Maintenance/MaintenanceVendors.vue';
import RentAgreements from '../../components/Catalogs/Maintenance/RentAgreements.vue';
import MaintenanceItems from '../../components/Catalogs/Maintenance/MaintenanceItems.vue';
import MaintenanceInventory from '../../components/Catalogs/Maintenance/MaintenanceInventory.vue';
import MaintenanceTireBrands from '../../components/Catalogs/Maintenance/MaintenanceTireBrands.vue';
import axios from 'axios';
export default {
    name: 'Catalogs',
    components: {
        VueContext,
        DynamicToolbar,
        ExpenseTypeCategorySubcategory,
        TaxRegions,
        MaintenanceVendors,
        RentAgreements,
        MaintenanceItems,
        MaintenanceInventory,
        MaintenanceTireBrands
    },
    data() {
        return {
            tab: null,
            catalogs: {
                maintenanceVendors: {
                    name: 'Maintenance Vendors',
                    foreignKey: 'maintenance_vendor_id',
                    primaryKey: 'id',
                    nameColumn: 'name',
                    headers: [],
                    items: [],
                    names: [],
                    get: '/v2/maintenance/vendors',
                    getNames: '/v2/maintenance/vendors/names',
                    post: '/v2/maintenance/vendors',
                    delete: '/v2/maintenance/vendors/{id}',
                    catalogKey: 'maintenanceVendors',
                    excludedFields: [
                        'region_id_vendor',
                        'qb_vendor_id',
                        'created_at',
                        'updated_at'
                    ]
                },
                taxRegions: {
                    name: 'Tax Regions',
                    foreignKey: 'maintenance_tax_region_id',
                    primaryKey: 'id',
                    nameColumn: 'name',
                    headers: [],
                    items: [],
                    names: [],
                    get: '/v2/maintenance/tax/region',
                    getNames: '/v2/maintenance/tax/region/names',
                    post: '/v2/maintenance/tax/region',
                    delete: '/v2/maintenance/tax/region/{id}',
                    catalogKey: 'taxRegions',
                    excludedFields: []
                },
                expenseCategories: {
                    name: 'Expense Categories',
                    foreignKey: 'maintenance_expense_category_id',
                    primaryKey: 'id',
                    nameColumn: 'name',
                    headers: [],
                    items: [],
                    names: [],
                    get: '/v2/maintenance/invoices/expenses/categories',
                    getNames:
                        '/v2/maintenance/invoices/expenses/categories/names',
                    post: '/v2/maintenance/invoices/expenses/categories',
                    catalogKey: 'expenseCategories',
                    excludedFields: []
                },
                // rentAgreements: {
                //     name: 'Rent Agreements',
                //     foreignKey: 'maintenance_vendor_rent_agreement_id',
                //     primaryKey: 'id',
                //     nameColumn: 'name',
                //     headers: [],
                //     items: [],
                //     names: [],
                //     get: '/v2/equipment/rent-agreements',
                //     getNames: '/v2/equipment/rent-agreements/names',
                //     post: '/v2/equipment/rent-agreements',
                //     catalogKey: 'rentAgreements',
                //     excludedFields: []
                // },
                maintenanceTireBrands: {
                    name: 'Tire Brands',
                    foreignKey: 'maintenance_tire_brand_id',
                    primaryKey: 'id',
                    nameColumn: 'name',
                    headers: [],
                    items: [],
                    names: [],
                    get: '/v2/maintenance/tire-brands',
                    // getNames: '/v2/maintenance/tire-brands/names',
                    // post: '/v2/maintenance/tire-brands'
                    delete: '/v2/maintenance/tire-brands/{id}',
                    catalogKey: 'maintenanceTireBrands',
                    excludedFields: [
                        'created_at',
                        'updated_at',
                    ]
                },
                items: {
                    name: 'Items/Parts',
                    foreignKey: 'maintenance_item_id',
                    primaryKey: 'id',
                    nameColumn: 'name',
                    headers: [],
                    items: [],
                    names: [],
                    get: '/v2/maintenance/inventory/items',
                    getNames: '/v2/maintenance/inventory/items/names',
                    post: '/v2/maintenance/inventory/items',
                    catalogKey: 'items',
                    excludedFields: [
                        'item_number',
                        'revision',
                        'maintenance_expense_subcategory_id',
                        'maintenance_manufacturer_id',
                        'created_at',
                        'updated_at',
                    ]
                },
                /*inventory: {
                    name: 'Inventory',
                    foreignKey: 'maintenance_inventory_id',
                    primaryKey: 'id',
                    nameColumn: 'name',
                    headers: [],
                    items: [],
                    names: [],
                    get: '/v2/maintenance/inventory',
                    getNames: '/v2/maintenance/inventory/names',
                    post: '/v2/maintenance/inventory'
                }*/
            },
            currentCatalog: null,
            currentCatalogName: null,
            currentCatalogHeaders: [],
            currentCatalogItems: [],
            currentItem: [],
            isLoading: false,
            form: {},
            selectedItem: null,
            currentDeleteItem: null,
            deleteDialog: false,
        };
    },
    computed: {
        catalogNames() {
            return Object.keys(this.catalogs);
        }
    },
    methods: {
        generateHeaders(items, catalogKey) {
            if (!items.length) return [];
            let headers = Object.keys(items[0]).map(key => ({
                text: key,
                value: key
            }));

            headers = headers.filter(hd => !this.catalogs[catalogKey].excludedFields.includes(hd.value));
            
            return this.formatHeaders(headers);
            //append the "Actions" header
            // headers.push({
            //     text: 'Actions',
            //     value: 'actions',
            //     sortable: false
            // });
        },
        formatHeaders(headers) {
            return headers.map(hd => {
                const words = hd.text.replace(/_/g, ' ').split(' ');
                const capitalizedWords = words.map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase());
                return {
                    text: capitalizedWords.join(' '),
                    value: hd.value
                }
            });
        },
        selectCatalog(catalog) {
            console.log('Selected catalog Name: ', catalog);
            //Remove spaces from the catalog name and set the first letter to lowercase
            catalog = catalog.replace(/\s/g, '');
            catalog = catalog.charAt(0).toLowerCase() + catalog.slice(1);
            console.log('Catalog Name: ', catalog);
            //Search for the catalog in the catalogs object
            this.currentCatalogName = catalog;

            this.currentCatalog = this.catalogs[catalog];
            this.currentCatalogHeaders = this.currentCatalog.headers;
            this.currentCatalogItems = this.currentCatalog.items;
        },
        loadCatalog(catalogKey) {
            console.log("Catalog name: ", catalogKey);
            this.isLoading = true;
            const catalog = this.catalogs[catalogKey];
            if (!catalog) return;
            axios
                .get(catalog.get)
                .then(response => {
                    this.catalogs[catalogKey].items = response.data;
                    this.catalogs[catalogKey].headers = this.generateHeaders(
                        response.data, catalogKey
                    );

                    this.currentCatalog = this.catalogs[catalogKey];
                    if (this.currentCatalog) {
                        this.currentCatalogHeaders =
                            this.currentCatalog.headers || [];
                        this.currentCatalogItems =
                            this.currentCatalog.items || [];
                    } else {
                        this.currentCatalogHeaders = [];
                        this.currentCatalogItems = [];
                    }

                    this.isLoading = false;
                })
                .catch(logErr);
        },
        async loadCatalogs() {
            const catalogEntries = Object.entries(this.catalogs);
            console.log("catalogEntries: ", catalogEntries);

            try {
                // Process the catalogs in batches of 3
                for (let i = 0; i < catalogEntries.length; i += 3) {
                    // Get the next three catalogs or whatever remains
                    const batch = catalogEntries.slice(i, i + 3);

                    // Load the catalogs concurrently in the current batch
                    const loadedCatalogs = await Promise.all(
                        batch.map(async ([key, catalog]) => {
                            const response = await axios.get(catalog.get);
                            return {
                                key,
                                data: {
                                    ...catalog,
                                    items: response.data,
                                    headers: this.generateHeaders(response.data, key)
                                }
                            };
                        })
                    );

                    // Once the batch is loaded, update the state
                    console.log("loadedCatalogs", loadedCatalogs);
                    loadedCatalogs.forEach(({ key, data }) => {
                        this.catalogs[key] = data;
                    });
                    console.log("catalogs: ", this.catalogs);
                }
            } catch (error) {
                logErr(error);
            }
        },
        deleteItem(item) {
            console.log('Delete item: ', item);
            this.currentDeleteItem = item.data;
            this.deleteDialog = true;
        },
        confirmDelete() {
            console.log("Confirm delete item: ", this.currentDeleteItem);

            let url = this.catalogs[this.currentDeleteItem.catalogKey].delete;
            url = url.replace('{id}', this.currentDeleteItem.id);

            console.log('url ', url);

            axios.delete(url)
                .then(response => {
                    console.log(response.data);
                    this.$store.dispatch('setSnackbar', {
                        text: 'Record deleted',
                        color: 'success'
                    });

                    this.loadCatalog(this.currentDeleteItem.catalogKey);
                    
                    this.deleteDialog = false;
                    this.currentDeleteItem = null;
                })
                .catch(error => {
                    console.log(error);
                    this.$store.dispatch('setSnackbar', {
                        text: 'Error deleting record',
                        color: 'error'
                    });

                    this.deleteDialog = false;
                    this.currentDeleteItem = null;
                });
        },
        openContextMenu({ event, item }) {
            this.selectedItem = item;
            this.$refs.catalogItem.open(event, { data: item });
        },
    },
    mounted() {
        this.loadCatalogs();
    }
};
</script>

<!-- <style scoped>
@import '~vue-context/dist/css/vue-context.css';
</style> -->
